module.exports = __webpack_public_path__ + "static/media/wellbeing-foundations-large@2x.d688e577.png";